import IconFilter from "@mui/icons-material/FilterAlt";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MapPillPanel } from "~/modules/map/components/MapPillPanel";
import CheckboxInput from "~/shared/components/CheckboxInput";
import FieldworkerSelect from "~/shared/components/FieldworkerSelect";

import { usePlannerV2VisitFilters } from "../../hooks/usePlannerV2VisitFilters";
import { FieldworkerTravelMethodFilter } from "../FieldworkerTravelMethodFilter";

export function PlannerV2VisitFilters() {
    const { t } = useTranslation("plannerV2");
    const { filterValues, toggleTravelMethod, setFilterValues, hasAnyFilters } = usePlannerV2VisitFilters();

    return (
        <MapPillPanel icon={<IconFilter />} title={t("visitFilters.title")} hasDot={hasAnyFilters}>
            <Stack>
                <FieldworkerTravelMethodFilter
                    selectedMethods={filterValues.filterFieldworkerTransportationMethods}
                    onChange={toggleTravelMethod}
                />
                <Box m={2}>
                    <FieldworkerSelect
                        label={t("visitFilters.fieldworkerFilter")}
                        value={filterValues.filterFieldworkerIds}
                        onChange={value => setFilterValues({ filterFieldworkerIds: value })}
                    />
                </Box>
                <Box m={2}>
                    <CheckboxInput
                        label={t("visitFilters.includeUnavailableFilter")}
                        value={filterValues.filterFieldworkerIncludeUnavailable}
                        onChange={value => setFilterValues({ filterFieldworkerIncludeUnavailable: value })}
                    />
                </Box>
            </Stack>
        </MapPillPanel>
    );
}
